import { Box } from '@material-ui/core';
import { getUsersByUserId, patchBlockUser, User } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';
interface BlockUserMessageProps {
  selectedUser: User;
  userId: string;
  opened: boolean;
  setOpened: (boolean) => void;
  handleClose;
}

export const BlockUserMessage = ({ selectedUser, userId, opened, setOpened, handleClose }: BlockUserMessageProps) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getUsersByUserId, { userId });
  const onBlockUser = async () => {
    await request(patchBlockUser, { userId: selectedUser.id });
    handleClose();
    revalidate();
  };
  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton disabled={loading} onClick={handleClose}>
            <Text tId="CANCEL" />
          </StandardButton>
          <StandardButton main loading={loading} onClick={() => onBlockUser()}>
            <Text tId={'BLOCK_USER'} />
          </StandardButton>
        </>
      }
    >
      <Box marginBottom={2}>
        <Font variant="h3" color="textPrimary">
          <Text tId={'BLOCK_USER'} />
        </Font>
      </Box>
      <Box pt={3}>
        <Font variant={'body2'} color={'textSecondary'}>
          <Text tId={'DO_YOU_WANT_TO_BLOCK_THE_USER'} dynamicDataTexts={[selectedUser.username]} />
        </Font>
      </Box>
    </NemuruDialog>
  );
};
